<template lang="pug">
  header.header
    ul.branding
      li.ms-branding
        a(:href="homeUrl" target="_blank") myStrength
      li.co-branding(v-if="partnerHeaderImageSrc")
        img(v-bind:src="partnerHeaderImageSrc" alt="Partner Logo")
    ul.links(v-if="!isSsoPatientView")
      li.search(v-if="isDashboardUser")
        router-link.search-link(to="/search" title="Search" aria-label="search") Search Users
          svg#search-icon.svgicon(data-name='search-icon', xmlns='http://www.w3.org/2000/svg', viewbox='0 0 16 16')
            title Search
            path(d=`M15.91,14.66a.34.34,0,0,1,.09.25.46.46,0,0,1-.09.28l-.72.69a.39.39,0,0,1-.28.13.3.3,0,0,1-.25-.12l-3.81-3.78a.42.42,0,0,1-.09-.25v-.44a6.71,6.71,0,0,1-2,
              1.17A6.28,6.28,0,0,1,6.5,13a6.31,6.31,0,0,1-3.27-.87A6.57,6.57,0,0,1,.88,9.77,6.31,6.31,0,0,1,0,6.5,6.31,6.31,0,0,1,.88,3.23,6.57,6.57,0,0,1,3.23.88,6.31,
              6.31,0,0,1,6.5,0,6.31,6.31,0,0,1,9.77.88a6.57,6.57,0,0,1,2.36,2.36A6.31,6.31,0,0,1,13,6.5a6.28,6.28,0,0,1-.42,2.28,6.71,6.71,0,0,1-1.17,2h.44a.34.34,0,0,1,
              .25.09ZM6.5,11.5A4.89,4.89,0,0,0,9,10.83,5,5,0,0,0,10.83,9a5,5,0,0,0,0-5A5,5,0,0,0,9,2.17a5,5,0,0,0-5,0A5,5,0,0,0,2.17,4a5,5,0,0,0,0,5A5,5,0,0,0,4,10.83,
              4.89,4.89,0,0,0,6.5,11.5Z`)
      li
        a(:href="settingsUrl" target="_blank") {{ username }}
      li
        a(href="#" v-on:click="logout()") Log Out
</template>

<script>
import { mapGetters } from 'vuex';
import auth from '@/services/authSvc.js';

export default {
  name: 'TheHeader',
  props: {
    logout: {
      type: Function,
      required: true
    },
    isSsoPatientView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      homeUrl: auth.getAppUrl() + '/v',
      settingsUrl: auth.getAppUrl() + '/v/settings'
    };
  },
  computed: {
    ...mapGetters(['isDashboardUser', 'username', 'partnerHeaderImageSrc'])
  }
};
</script>

<style lang="scss" scoped>
.header {
  @include position(fixed, 0 0 null 0);
  z-index: 1000;
  width: 100%;
  min-width: $bp4;
  height: $header-height;
  margin: 0 auto;
  padding: $small-spacing;
  background: #fff;
  @include drop-shadow;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.branding,
.links {
  @include zero;
  max-width: 50%;
  display: flex;
  align-items: center;
}
.branding {
  overflow: hidden;
}
.links li {
  margin-right: $base-spacing;
}
.ms-branding {
  display: block;
  @include zero;
  margin: 0 $base-spacing 0 0;
  font-size: $base-font-size;
  font-weight: $base-font-weight;
  width: 152px;
  height: 40px;
  a {
    display: block;
    @include zero;
    @include size(152px, 40px);
    background: transparent url(/static/images/myStrength-logo.svg) no-repeat
      50% 50%;
    background-size: 100%;
    text-indent: -9999em;
    overflow: hidden;
  }
}
.co-branding {
  img {
    @include zero;
    display: block;
    max-height: 60px;
  }
}
.search {
  .search-link {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $xs-spacing $small-spacing;
    border-radius: $base-border-radius;
    font-family: $base-font-family;
    background-image: linear-gradient(
      to bottom,
      #fff 40%,
      $md-grey-50 80%,
      $md-grey-100
    );
    border: 1px solid $md-grey-300;
    transition: all 0.25s ease;
    &:hover,
    &:focus,
    &:active {
      background-image: linear-gradient(to top, #fff 80%, $md-grey-50 40%, $md-grey-100);
      border-color: $action-color;
      color: $action-color;
      outline: none;
    }
    .svgicon {
      @include zero;
      @include size(16px);
      margin-left: 0.5em;
      vertical-align: middle;
    }
  }
}
</style>
